import React from 'react'
import { Grid, TextField, Typography } from '@material-ui/core'
import BaseDialog from './general/BaseDialog'
import DatePicker from './general/DatePicker'
import { withStyles } from '@material-ui/core'
import { styles } from '../styles/js/baseDialog'

const DialogSearchComponent = ({
  classes,
  dialog,
  setDialog,
  searchState,
  setSearchState,
  search,
  clearSearch,
}) => {
  return (
    <BaseDialog
      dialog={dialog}
      setDialog={setDialog}
      title={'Filtrar'}
      description={
        'Utilize os campos abaixo para filtrar fotos por data de envio ou pelo nome do telespectador.'
      }
      actionTitle={'Buscar'}
      secondaryActionTitle={'Limpar Busca'}
      handleAction={() => search(searchState)}
      handleSecondaryAction={clearSearch}
      disabledAction={
        searchState.data_inicio &&
        searchState.data_fim &&
        searchState.data_inicio > searchState.data_fim
      }
      slug={'filtrar'}
      fullWidth={true}
      maxWidth={'sm'}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant='h6' className={classes.label}>
            Data de início
          </Typography>

          <DatePicker
            id='data_inicio'
            name='data_inicio'
            value={searchState.data_inicio}
            onChange={value =>
              setSearchState({ ...searchState, data_inicio: value })
            }
            disablePast={false}
            disableFuture={false}
            margin='none'
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant='h6' className={classes.label}>
            Data de fim
          </Typography>

          <DatePicker
            id='data_fim'
            name='data_fim'
            value={searchState.data_fim}
            onChange={value =>
              setSearchState({ ...searchState, data_fim: value })
            }
            disablePast={false}
            disableFuture={false}
            margin='none'
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Nome
          </Typography>

          <TextField
            id='telespectador'
            name='telespectador'
            value={searchState.telespectador || ''}
            onChange={event =>
              setSearchState({
                ...searchState,
                telespectador: event.target.value,
              })
            }
            placeholder={'Exemplo: Joana Aparecida dos Santos'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
          />
        </Grid>

        {searchState.data_inicio &&
          searchState.data_fim &&
          searchState.data_inicio > searchState.data_fim && (
            <Grid item xs={12}>
              <Typography variant='subtitle2' color='error'>
                * O campo{' '}
                <span style={{ fontWeight: 600 }}>Data de início</span> deve ser
                menor que o campo{' '}
                <span style={{ fontWeight: 600 }}>Data de fim</span>
              </Typography>
            </Grid>
          )}
      </Grid>
    </BaseDialog>
  )
}

export default withStyles(styles)(DialogSearchComponent)
